import React, { createContext, useContext, useEffect, useState } from 'react';
import { LANGS, translations } from '../lib/i18n';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('gn_lang') || 'it');

  useEffect(() => {
    const meta = LANGS.find((l) => l.code === lang) || LANGS[0];
    document.body.setAttribute('dir', meta.dir);
    document.documentElement.setAttribute('lang', lang);
    localStorage.setItem('gn_lang', lang);
  }, [lang]);

  const t = (path) => {
    const parts = path.split('.');
    let cur = translations[lang] || translations.it;
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
